export const iconsItems = {
	'3m':'3m.svg',
	orng:'orng.svg',
	suncor_energy:'suncor.svg',
	'try':'try.svg',
	's&p_500':'s-and-p-500.svg',
	smi20:'smi20.svg',
	target:'target.svg',
	td:'td.svg',
	tobaco:'tobaco.png',
	ycc:'ycc.jpg',
	lend:'lend.svg',
	strat:'strat.svg',
	aave:'aave.svg',
	abbv:'abbv.svg',
	activision_blizzard:'activision-blizzard.svg',
	ada:'ada.svg',
	//eslint-disable-next-line
	adidas:'adidas.svg',
	addyy:'adidas.svg',
	adobe_inc:'adobe.svg',
	ads:'adidas.svg',
	afterpay_ltd:'afterpay.png',
	ahold:'ahold.svg',
	aig:'aig.svg',
	alcoa:'alcoa.svg',
	alexion_pharmaceuticals_inc:'alexion.png',
	alibaba:'alibaba.svg',
	alphabet:'alphabet.svg',
	aluminum:'aluminum.svg',
	alv:'alv.svg',
	am_express:'amexpress.svg',
	amazon:'amazon.svg',
	amc:'amc.svg',
	amd:'amd.svg',
	american_airlines:'american-airlines.svg',
	amp:'amp.svg',
	ape:'ape.svg',
	aphria_inc:'aphria.png',
	apple:'apple.svg',
	aramco:'aramco.svg',
	ark:'ark.svg',
	asml:'asml.svg',
	aston_martin:'aston-martin.svg',
	at_t:'at&t.svg',
	arb:'arb.svg',
	asx:'asx.svg',
	aud:'aud.svg',
	aurora_cannabis_inc:'aurora-cannabis.svg',
	avax:'avax.svg',
	baidu:'baidu.svg',
	ballard_power:'ballard-power.svg',
	bama:'brookfield-renewable.svg',
	band:'band.svg',
	bank_of_america:'bank-of-america.svg',
	barclays:'barclays.svg',
	bay:'bay.svg',
	bbva:'bbva.svg',
	bch:'bch.svg',
	berkshire:'berkshire.svg',
	bilibili_inc:'bilibili.svg',
	biontech_se:'biontech.svg',
	bit:'bit.svg',
	bkt:'bkt.svg',
	bmw:'bmw.png',
	bnb:'bnb.svg',
	bnt:'bnt.svg',
	boeing:'boeing.svg',
	bolsa:'bolsa.svg',
	bp:'bp.svg',
	british_american_t:'british-american-tobacco.svg',
	brookfield_renewable:'brookfield-renewable.svg',
	bsv:'bsv.svg',
	btc:'btc.svg',
	btt:'btt.svg',
	busd:'busd.svg',
	cabk:'cabk.svg',
	cac_40:'cac-40.svg',
	ndx100:'ndx100.svg',
	bist100:'ndx100.svg',
	omxs30:'omxs30.svg',
	nikkei_225:'nikkei-225.svg',
	s_and_p_500:'s-and-p-500.svg',
	cad:'cad.svg',
	cake:'cake.svg',
	canopy_growth_corporation:'canopy-growth.svg',
	caterpillar:'caterpillar.svg',
	cba:'cba.svg',
	cbd:'cbd.svg',
	cenovous_energy:'cenovus-energy.svg',
	chevron:'chevron.svg',
	chf:'chf.svg',
	china_mob:'china-mob.svg',
	cisco:'cisco.svg',
	citigroup:'citigroup.svg',
	clearway_energy:'clearway-energy.svg',
	clorox:'clorox.svg',
	coca_cola:'coca-cola.svg',
	cocoa:'cocoa.svg',
	coffee:'coffee.svg',
	coin:'coin.svg',
	colgate:'colgate.svg',
	comp:'comp.svg',
	copper:'copper.svg',
	corn:'corn.svg',
	cotton:'cotton.svg',
	coty_inc:'coty-inc.svg',
	cro:'cro.svg',
	cron:'cronos-group.svg',
	crsp:'crsp.svg',
	crsr:'crsr.svg',
	crude_oil:'crude-oil.svg',
	//eslint-disable-next-line
	crude_oil_wti:'crude-oil.svg',
	//eslint-disable-next-line
	brent_oil:'crude-oil.svg',
	ctsi:'ctsi.svg',
	daimler_ag:'daimler-ag.svg',
	dash:'dash.svg',
	dax:'dax.svg',
	dbk:'dbk.svg',
	denbury_resources:'denbury-resources.svg',
	disney:'disney.svg',
	dkk:'dkk.svg',
	doge:'doge.svg',
	dot:'dot.svg',
	dow:'dow-30.svg',
	dropbox:'dropbox.svg',
	e__on:'e-on.svg',
	easyjet:'easyjet.svg',
	ebay:'ebay.svg',
	ekrona:'ekrona.png',
	electarts:'electronic-arts.svg',
	enj:'enj.svg',
	el:'el.svg',
	eos:'eos.svg',
	essex_property:'essex_property.svg',
	etc:'etc.svg',
	etfmg_alternative_harvest:'etfmg.svg',
	eth:'eth.svg',
	eur:'eur.svg',
	eurt:'eurt.svg',
	euro_stoxx_50:'euro-stoxx-50.svg',
	exxon_mobil:'exxon.svg',
	//eslint-disable-next-line
	exxonmobil:'exxon.svg',
	ferrari_nv:'ferrari.svg',
	fiat:'fiat.png',
	fil:'fil.svg',
	first_solar:'first-solar.svg',
	fiverr:'fiverr.svg',
	fr__telecom:'fr_telecom.png',
	freeport_mcmoran:'freeport-mcmoran.svg',
	ftm:'ftm.svg',
	ftse_100:'uk-100.svg',
	ustech:'ndx100.svg',
	ftse_mib:'ftse-mib.svg',
	ftt:'ftt.svg',
	fun:'fun.svg',
	game_stop:'gamestop.svg',
	gas:'gas.svg',
	gazprom:'gazprom.svg',
	gbp:'gbp.svg',
	en:'gbp.svg',
	de:'de.svg',
	fr:'fr.svg',
	pt_pt:'pt.svg',
	pt_br:'br.svg',
	it:'it.svg',
	ar:'ar.svg',
	es:'es.svg',
	general_motors:'general-motors.svg',
	gild:'gilead.svg',
	gitlab_inc:'gitlab.svg',
	glaxosmithkline:'glaxosmithkline.svg',
	glencore:'glencore.svg',
	gold:'gold.svg',
	goldman_sachs:'golden-sachs.svg',
	gopro:'gopro.svg',
	gw_pharma:'gw-pharma.png',
	harley:'harley-davidson.svg',
	hbar:'hbar.svg',
	heineken:'heineken.svg',
	hkd:'hkd.svg',
	home_depot:'home-depot.svg',
	hp:'hp.svg',
	ht:'ht.svg',
	huf:'huf.svg',
	ibex:'ibex-35.svg',
	ibm:'ibm.svg',
	imoex:'imoex.svg',
	ice:'ice.svg',
	icp:'icp.svg',
	illumina_inc:'illumina.svg',
	ils:'ils.svg',
	imperial_oil:'imperial-oil.svg',
	imo:'imperial-oil.svg',
	intel:'intel.svg',
	invitae_cor:'invitae.svg',
	iota:'iota.svg',
	iqiyi_inc:'iqiyi.svg',
	jnj:'johnson-and-johnson.svg',
	jp_morgan_chase:'jpmorgan-chase.svg',
	jpy:'jpy.svg',
	ja:'jpy.svg',
	kmd:'kmd.svg',
	kodal_minerals:'kodal.jpg',
	krw:'krw.svg',
	lcid:'lcid.svg',
	lead:'lead.svg',
	lha:'lha.svg',
	link:'link.svg',
	lloyds_bank:'lloyds.svg',
	lockheed:'lockheed.svg',
	lowe_s:'lowe-s.svg',
	lsk:'lsk.svg',
	ltc:'ltc.svg',
	luna:'luna.svg',
	lyft:'lyft.svg',
	map:'map.svg',
	mastercard:'mastercard.svg',
	matic:'matic.svg',
	mattel_inc:'mattel.svg',
	mcdonald_s:'mcdonalds.svg',
	meta:'meta.svg',
	mgm_resorts_international:'mgm-resorts.svg',
	micron_technologies:'micron-technology.svg',
	microsoft:'microsoft.svg',
	moderna:'moderna.svg',
	mxn:'mxn.svg',
	nab:'nab.svg',
	nasdaq:'nasdaq-100.svg',
	natural_gas:'natural-gas.svg',
	neo:'neo.svg',
	netease:'netease.svg',
	netflix:'netflix.svg',
	nextera_energy:'nextera-energy.svg',
	nike:'nike.svg',
	nintendo:'nintendo.svg',
	nio:'nio.svg',
	nok:'nok.svg',
	nokia:'nokia.svg',
	ntgy:'ntgy.svg',
	nu_holdings_ltd:'nu.svg',
	nvidia:'nvidia.svg',
	nvda:'nvidia.svg',
	nxpi:'nxpi.svg',
	nzd:'nzd.svg',
	ocdo:'ocado-group.svg',
	omg:'omg.svg',
	one:'one.svg',
	onyx:'onyx.svg',
	oracle:'oracle.svg',
	oran:'orange.svg',
	orgn:'orgn.svg',
	peloton:'peloton.svg',
	pepsico:'pepsico.svg',
	pfizer:'pfizer.svg',
	philipmoris:'philip-morris.svg',
	platinum:'platinum.svg',
	pln:'pln.svg',
	phmr:'phmr.svg',
	pri:'pri.svg',
	plt:'palantir.svg',
	powr:'powr.svg',
	vodafone:'vodafone.svg',
	tencent_holdings:'tencent_holdings.svg',
	t:'t.svg',
	smmny:'smmny.svg',
	shop:'shop.svg',
	sftbf:'sftbf.svg',
	ryaay:'ryaay.svg',
	ry:'ry.svg',
	rkuny:'rkuny.svg',
	rcia:'rcia.svg',
	rblx:'rblx.svg',
	oxy:'oxy.svg',
	ocpny:'ocpny.svg',
	nsany:'nsany.svg',
	ngt:'ngt.svg',
	fujhy:'fujhy.svg',
	foot_locker:'foot_locker.svg',
	fnv:'fnv.svg',
	fmg:'fmg.svg',
	cp:'cp.svg',
	cnr:'cnr.svg',
	azn:'azn.svg',
	anz:'anz.svg',
	ac:'ac.svg',
	sxp:'sxp.svg',
	grt:'grt.svg',
	fet:'fet.svg',
	cgpt:'cgpt.svg',
	'procter_&_gamble':'procter-and-gamble.svg',
	qqq:'qqq.svg',
	qsp:'qsp.svg',
	qualcomm:'qualcomm.svg',
	rbc:'rbc.svg',
	realty_income_corp:'realty-income.svg',
	renault:'renault.svg',
	rep:'rep.svg',
	rhm: 'rhm.svg',
	rio:'rio.svg',
	rivian:'rivian.svg',
	roku_inc:'roku.svg',
	rosneft:'rosneft.svg',
	rts_future:'rts-future.svg',
	rub:'rub.svg',
	ru:'rub.svg',
	rwe:'rwe.svg',
	san:'san.svg',
	sand:'sand.svg',
	sft:'shift-technologies.svg',
	sgd:'sgd.svg',
	sgre:'sgre.svg',
	sgef:'societe-generale.svg',
	shib:'shib.svg',
	sie:'siemens.svg',
	silver:'silver.svg',
	smg:'scotts-miracle-gro-company.svg',
	snap:'snap.svg',
	snx:'snx.svg',
	sol:'sol.svg',
	solaredge_technologies:'solaredge-technologies.svg',
	sony:'sony.svg',
	soybeans:'soybeans.svg',
	spotify:'spotify.svg',
	square_inc:'block.svg',
	starbucks:'starbucks.svg',
	str:'str.svg',
	sugar:'sugar.svg',
	sun:'sun.svg',
	tadawul:'tadawul.svg',
	tata_motors:'tata.svg',
	tef:'telefonica.svg',
	//eslint-disable-next-line
	tel_aviv_35:'ta-53-index.svg',
	telefonica:'telefonica.svg',
	tes:'tes.png',
	tesla_motors:'tesla.svg',
	theta:'theta.svg',
	tilray_inc:'tilray.svg',
	tmus:'t-mobile.svg',
	trinseo:'trinseo.svg',
	tripadvisor:'tripadvisor.svg',
	trx:'trx.svg',
	tsco:'tsco.svg',
	tsm:'tsm.svg',
	tsx:'tsx.svg',
	ttcf:'ttcf.svg',
	twitter:'twitter.svg',
	uber:'uber.svg',
	uni:'uni.svg',
	usd:'usd.svg',
	usdt:'usdt.svg',
	verizon:'verizon.svg',
	vet:'vet.svg',
	virgin_galactic:'virgin-galactic.svg',
	visa:'visa.svg',
	vow:'volkswagen.svg',
	wal_mart:'wal-mart.svg',
	wbc:'wbc.svg',
	weed: 'weed.svg',
	wirecard:'wirecard.svg',
	work:'work.svg',
	wynn_resorts:'wynn-resorts.svg',
	xcel_energy:'xcel-energy.svg',
	xem:'xem.svg',
	xlm:'xlm.svg',
	xmr:'xmr.svg',
	xpeng:'xpeng.svg',
	xrp:'xrp.svg',
	xtz:'xtz.svg',
	xvg:'xvg.svg',
	yandex:'yandex.svg',
	yfi:'yfi.svg',
	zar:'zar.svg',
	zec:'zec.svg',
	zinc:'zinc.svg',
	zoom:'zoom.svg',
	gpt:'cgpt.svg',
	zrx:'zrx.svg',
	zh_hans:'zh.svg'
}

